module.exports = __webpack_public_path__ + "img/grid-item-kynorelle-05.f6428617.webp";